import { FormField, FormLabel } from "@impero-com/ui";
import Skeleton from "react-loading-skeleton";

import * as theme from "./theme.css";

interface InputSkeletonProps {
    label?: string;
    error?: string;
    enableAnimation?: boolean;
    className?: string;
}
export const InputSkeleton = ({
    label,
    error,
    enableAnimation,
    className,
}: InputSkeletonProps) => {
    return (
        <FormField className={className} error={error}>
            {label && <FormLabel>{label}</FormLabel>}
            <Skeleton
                enableAnimation={enableAnimation}
                className={theme.inputSkeleton}
            />
        </FormField>
    );
};
